export class ClipboardUtil {
	static copyTextToClipboard(text: string) {
		(navigator as any).clipboard.writeText(text).then(() => {});
	}
}
